import { instance } from 'services';
import { IFindFnReturn, IQueryParams, IResponse } from 'services/types.d';

import { IReadOnlyResource } from './types.d';

export const SitiReportCodeResources = {
  findAll: (params?: IQueryParams): Promise<IFindFnReturn<IReadOnlyResource>> =>
    instance.get('/siti-report-code/', { params }),

  findByID: (id: number | string): Promise<IResponse<IReadOnlyResource>> =>
    instance.get(`/siti-report-code/${id}`),
};
